var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueToggles',{attrs:{"value":_vm.value,"unchecked-bg":"#6A7A8A","checked-bg":"#0EAD69","height":"24","width":"44","disabled":_vm.disabled},on:{"click":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }